import {
  Box,
  Checkbox,
  Chip,
  Collapse,
  FormControlLabel,
  FormGroup,
  List,
  ListItemButton,
  ListSubheader,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { MdClear } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { ieltsCourseManagmentCourseLiveClassFindAction, ieltsLiveClassfilterAction } from "../../../../actions/IeltsActions/courseManagmentAction";
import LiveTable from "./LiveTable";
import PremissionDialog from "../../../customComponent/premissionDialog";
import usePrivilegeCheck from "../../../../constants/customHooks/UsePrivilegeCheck";
import IeltsFilter from "../examTips/ExamFilter"

function IeltsLiveClassMain({ subMenu }) {
  const dispatch = useDispatch();
  const [liveClassList, setLiveClassList] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);


  let {
    ieltsCourseManagmentCourseLiveClassFindSuccess,
    ieltsCourseManagmentCourseLiveClassFinderror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentCourseLiveClassFind;
  });

  let {
    ieltsCourseManagmentCourseLiveClassStatusChangeSuccess,
    ieltsCourseManagmentCourseLiveClassStatusChangeerror,
  } = useSelector((state) => {
    return state.ieltsCourseManagmentCourseLiveClassStatusChange;
  });

  const { ieltsLiveClassFilterSuccess } = useSelector((state) => state.ieltsLiveClassFilter)

  useEffect(() => {
    dispatch(ieltsCourseManagmentCourseLiveClassFindAction());
  }, [dispatch, ieltsCourseManagmentCourseLiveClassStatusChangeSuccess]);

  useEffect(() => {
    if(ieltsLiveClassFilterSuccess) {
      setLiveClassList(ieltsLiveClassFilterSuccess?.data)
    }
  }, [ieltsLiveClassFilterSuccess])

  useEffect(() => {
    if (ieltsCourseManagmentCourseLiveClassFindSuccess) {
      setLiveClassList(ieltsCourseManagmentCourseLiveClassFindSuccess?.data);
    }
  }, [ieltsCourseManagmentCourseLiveClassFindSuccess]);

  const columns = [
    { title: "SL NO", field: "sl" },
    { title: "COURSE", field: "course" },
    { title: "CATEGORY", field: "category" },
    { title: "TOPIC", field: "topic" },
    { title: "TEACHER", field: "teacher" },
    { title: "DATE", field: "date" },
    { title: "MEETING CHANNEL", field: "channel" },
    { title: "TIME", field: "time" },
    { title: "STATUS", field: "status" },
  ];

  const [secListopen, setSecListOpen] = useState(true);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [categoryList, setCategoyList] = useState([
    "Listening",
    "Reading",
    "Speaking",
    "Writing",
    "Grammar",
    "Exam Tips",
    "Question Bank",
  ]);

  // handleFilter function

  const handleFilterFunction = (filterValue, checkedStatus) => {
    setSelectedCategory(filterValue === selectedCategory ? null : filterValue);
    if (checkedStatus) {
      setLiveClassList(
        ieltsCourseManagmentCourseLiveClassFindSuccess?.data?.filter(
          (topics, index) => {
            return filterValue == topics.ielts_category.CategoryName;
          }
        )
      );
    } else {
      setLiveClassList(ieltsCourseManagmentCourseLiveClassFindSuccess.data);
    }
  };

  // Handle ClearAll function

  const handleClearAllFunction = () => {
    setLiveClassList(ieltsCourseManagmentCourseLiveClassFindSuccess.data);
    setSelectedCategory(null);
  };

  const handleClick2 = () => {
    setSecListOpen(!secListopen);
  };

  const [ids, setIds] = useState([]);

  const selectBoxIdPassHandler = (ids) => {
    setIds(ids);
  };

  const [page, setPage] = useState(10);
  const [pageError, setPageError] = useState("");

  const handlePageSearch = (e) => {
    const { value } = e.target;
    if (value >= 0) {
      setPage(value);
    }
    if (value >= 10) {
      setPageError("");
    } else {
      setPageError("please choose a value greater than 10");
    }
  };

  const leadFilterFunction = (filterData) => {
    try {
      dispatch(ieltsLiveClassfilterAction(filterData))
    } catch(error) {
      console.error(error);
    }
  }

  return (
    <>
      <Box
        sx={{
          mt: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            lg: "330px 1fr",
          },
          gap: "25px",
        }}
      >
        <Box>
          {selectedCategory && (
            <Chip
              sx={{
                "&.MuiChip-root": {
                  pl: "5px",
                  pr: "5px",
                },
              }}
              label={
                <Typography
                  sx={{
                    fontSize: "10px",
                    fontWeight: "700",
                    color: "rgba(88, 94, 106, 1)",
                  }}
                >
                  Category:{" "}
                  <Typography
                    sx={{
                      fontSize: "10px",
                      fontWeight: "400",
                    }}
                    component={"span"}
                  >
                    {selectedCategory}
                  </Typography>
                </Typography>
              }
              onDelete={handleClearAllFunction}
            />
          )}

          <IeltsFilter
            leadFilterFunction={leadFilterFunction}
            componentName="liveClass"
          />

        </Box>

        <LiveTable
          data={liveClassList}
          columns={columns}
          component="questionBank"
          selectBoxIdPassHandler={selectBoxIdPassHandler}
          pageNumber={page}
          subMenu={subMenu}
        />
      </Box>


    </>
  );
}

export default IeltsLiveClassMain;
